angular
    .module('satv.search')
    .controller('SearchFormCtrl', function () {
        "use strict";
    });



// WEBPACK FOOTER //
// ./vendor/sonyatv/searchclientbundle/Resources/js/angular/controllers/SearchFormCtrl.js